<template lang="pug">
  div
    b-row
      .col-xl-10
        panel(:title='$t("ui.game_result")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-4.col-xl-6.mb-1
                //- DateRangePicker(:value="dateRange")
                DatePicker
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                b-input-group(:prepend="$t('ui.product')" size="sm")
                  b-form-select(
                    ref="product"
                    v-model="product"
                    :options="getPlatformLookUp()"
                    size="sm"
                    :disabled="loading"
                    @change="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.member_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="member_id"
                    :dirty="$v.member_id.$dirty"
                    :error="$v.member_id.$error"
                    :placeholder='$t("ui.member_id")'
                    v-model.trim.lazy="$v.member_id.$model"
                    size="sm"
                    :disabled="loading"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                b-input-group(:prepend="$t('ui.sport_type')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="sport_type"
                    :placeholder='$t("ui.sport_type")'
                    v-model="sport_type"
                    size="sm"
                    :disabled="loading"
                    @keyup.enter.native="submit"
                  )
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                b-input-group(:prepend="$t('ui.league_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="league_id"
                    :placeholder='$t("ui.league_id")'
                    v-model="league_id"
                    size="sm"
                    :disabled="loading"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                b-input-group(:prepend="$t('ui.match_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="match_id"
                    :placeholder='$t("ui.match_id")'
                    v-model="match_id"
                    size="sm"
                    :disabled="loading"
                    @keyup.enter.native="submit"
                  )
              //- .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(v-if="product != 'SPORTSBOOK'")
              //-   b-input-group(:prepend="$t('ui.game_name')" size="sm")
              //-     DebounceInput(
              //-       type="text"
              //-       ref="game_name"
              //-       :placeholder='$t("ui.game_name")'
              //-       v-model="game_name"
              //-       size="sm"
              //-       :disabled="loading"
              //-       @keyup.enter.native="submit"
              //-     )
              //- .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1(v-if="product != 'SPORTSBOOK'")
              //-   b-input-group(:prepend="$t('ui.game_provider')" size="sm")
              //-     DebounceInput(
              //-       type="text"
              //-       ref="game_provider"
              //-       :placeholder='$t("ui.game_provider")'
              //-       v-model="game_provider"
              //-       size="sm"
              //-       :disabled="loading"
              //-       @keyup.enter.native="submit"
              //-     )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-form-checkbox(
                  ref="working_date"
                  v-model="working_date"
                ) {{ this.$t("message.search_with_working_date") }}
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.d-flex
                SubmitButton.mr-2(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
                .ml-auto
                  jsonToExcel(v-if="gameResultList.length > 0" mode="GameResult" :date="dateRange")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" responsive :no-local-sorting="true" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="gameResultList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(b-slot:table-busy)
                    .text-center.text-danger
                      b-spinner.align-middle
                      strong Loading...
                  template(v-slot:thead-top="row")
                    tr
                      th.bg-grey-lighter(colspan="6")
                      th.text-center.bg-grey-transparent-1(colspan="1") {{ $t("ui.member") }}
                      //- // th.text-center.bg-grey-transparent-3(colspan="1") {{ $helpers.getUplineName(downlineLevel) }}
                      //- // th.text-center.bg-grey-transparent-5(colspan="3") {{ $t("ui.company") }}
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(member_id)="row")
                    span {{ row.item.member_id.toUpperCase() }}
                  template(v-slot:cell(bet_time)="row")
                    template(v-if="product == 'TOURNAMENT'")
                        span {{ $moment(row.item.bet_on).format("YYYY-MM-DD HH:mm:ss") }}
                        br
                        span #[b {{ row.item.bet_id }}]
                    template(v-else)
                      span {{ $moment(row.item.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
                      br
                      span #[b {{ row.item.result_id }}]
                      br
                      span {{ row.item.ip }}
                  template(v-slot:cell(event)="row")
                    template(v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                      template(v-if="row.item.bet_type == 'PARLAY'")
                        span(v-if="row.item.bet_type_share == 'PARLAYMMO'") #[b {{ $t("ui.mmo_parlay") }}]
                        span(v-else) #[b {{ $t("ui.mix_parlay") }}]
                        div
                          span.mr-1 {{ $helpers.displayBetDetail(row.item) }} @
                          span {{ row.item.odds_display_bet }}
                      template(v-else)
                        div
                          span.badge.bg-blue-darker.mr-1 {{ row.item.league_id }}
                          span {{ getName(row.item.league_id, 0) }}
                        div(v-if="row.item.home_team_name != null")
                          span.badge.bg-orange-darker.mr-1 {{ row.item.match_id }}
                          span.mr-1(:class="$helpers.getTeamClass(row.item, 0)") {{ getName(row.item.match_id, 1) }}
                          span.mr-1 vs
                          span(:class="$helpers.getTeamClass(row.item, 1)") {{ getName(row.item.match_id, 2) }}
                        div(v-if="row.item.match_time")
                          span.mr-1 {{ $moment(row.item.match_time).format("YYYY-MM-DD HH:mm:ss") }}
                          span(v-if="row.item.market_type == 3 && ['HDP', 'OU'].includes(row.item.bet_type)") ({{ row.item.home_running_score}} - {{ row.item.away_running_score }})
                    template(v-else-if="product == 'TOURNAMENT'")
                      template(v-if="row.item.room_type")
                        span {{ $t("ui.room_" + row.item.room_type) }}
                        br
                      span.mr-1 No.{{ row.item.room_id }}
                      template(v-if="row.item.position")
                        i.fas.fa-trophy.gold-trophy(v-if="row.item.position == 1")
                        i.fas.fa-trophy.silver-trophy(v-if="row.item.position == 2")
                        i.fas.fa-trophy.bronze-trophy(v-if="row.item.position == 3")
                    template(v-else)
                      div
                        span {{ row.item.game_provider }} @ {{ row.item.bet_id }}
                      div
                        span {{ row.item.game_name }}
                  template(v-slot:cell(detail)="row")
                    template(v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                      template(v-if="row.item.bet_type == 'PARLAY'")
                        span @ {{ row.item.odds_display }}
                        div
                          span.label.bg-black {{ $t("ui.details") }}
                          template(v-if="row.item.bet_type_share == 'PARLAYMMO'")
                            i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getParlayDetailMMO(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                          template(v-else)
                            i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getParlayDetail(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                      template(v-else)
                        div.mb-1
                          //- span.label.bg-black #[b {{ $tc("m.BT_" + row.item.bet_type, 2) }}]
                          span.label.bg-black #[b {{ getBetType(row.item) }}]
                        div
                          span(:class="$helpers.getBetClass(row.item)") {{ $helpers.getBetDetail(row.item, getName(row.item.match_id, 1), getName(row.item.match_id, 2)) }}
                        div
                          span {{ $helpers.displayBetDetail(row.item) }}
                          br
                          span.mr-1 {{ $helpers.getDisplayBall(row.item) }} @
                          span #[b {{ row.item.odds_display }}] {{ $helpers.getOddsType(row.item) }}
                          br
                          span.mr-1 {{ row.item.bet_type.charAt(row.item.bet_type.length-1) == 'H' ? 'FH' : 'FT' }}
                          span {{ row.item.home_score }} - {{ row.item.away_score }}
                    template(v-else-if="product == 'TOURNAMENT'")
                      .small
                        span.mr-1 {{ $t("ui.turnover") }} @
                        span(:class="$helpers.getNumberClass(row.item.turnover)") #[b {{ row.item.turnover | currency }} ]
                      .small
                        span.mr-1 {{ $t("ui.valid_turnover") }} @
                        span(:class="$helpers.getNumberClass(row.item.valid_turnover)") #[b {{ row.item.valid_turnover | currency }} ]
                      .small
                        span.mr-1 {{ $t("ui.payout") }} @
                        span(:class="$helpers.getNumberClass(row.item.payout)") #[b {{ row.item.payout | currency }} ]
                    template(v-else)
                      span.small.mr-1 {{ $t("ui.turnover") }} @
                      span.small(:class="$helpers.getNumberClass(row.item.turnover)") #[b {{ row.item.turnover | currency }} ]
                      br
                      span.small.mr-1 {{ $t("ui.valid_turnover") }} @
                      span.small(:class="$helpers.getNumberClass(row.item.valid_turnover)") #[b {{ row.item.valid_turnover | currency }} ]
                      br
                      span.small.mr-1 {{ $t("ui.payout") }} @
                      span.small(:class="$helpers.getNumberClass(row.item.payout)") #[b {{ row.item.payout | currency }} ]
                      br
                      //- // span
                      //- //   a(:href="resultUrl(row.item)" :title='$t("ui.game_result")' target="result" onclick="window.open(this.href,'result','top=10,height=600,width=400,status=no,toolbar=no,menubar=no,location=no');return false;")
                      //- //     i.fas.fa-poll
                  template(v-slot:row-details="row")
                    b-table#innerTable.table-sm(show-empty :items="parlayList" :fields="vDfields")
                      template(v-slot:cell(index)="row")
                        span {{ row.index + 1 }}
                      template(v-slot:cell(working_date)="row")
                        span {{ $moment(row.item.working_date).format("YYYY-MM-DD HH:mm:ss") }}
                      template(v-slot:cell(league_name)="row")
                        span {{ getParlayName(row.item.league_id, 0) }}
                      template(v-slot:cell(home_team_name)="row")
                        span(:class="row.item.home_giving == 1 ? 'text-danger' : 'text-info'") {{ getParlayName(row.item.match_id, 1) }}
                      template(v-slot:cell(away_team_name)="row")
                        span(:class="row.item.home_giving == 0 ? 'text-danger' : 'text-info'") {{ getParlayName(row.item.match_id, 2) }}
                      template(v-slot:cell(full_half)="row")
                        span {{ (row.item.full_half == 1) ? $t("ui.full_time") : $t("ui.half_time") }}
                      template(v-slot:cell(running_score)="row")
                        span {{ row.item.running_score ? row.item.running_score : '-' }}
                      template(v-slot:cell(status)="row")
                        template(v-if="isMMO")
                          span {{ $helpers.showWinStatusMMO(row.item) }}
                        template(v-else)
                          span {{ $helpers.showWinStatus(row.item) }}
                  template(v-slot:cell(jackpot_payout)="row" v-if="['TOURNAMENT'].includes(product)")
                    span(:class="$helpers.getNumberClass(row.item.jackpot_payout)") #[b {{ row.item.jackpot_payout | currency }} ]
                  //- // template(v-slot:cell(pt_share)="row")
                  //- //   div(v-if="downlineLevel == 6")
                  //- //     span.small {{ $helpers.getUplineName(6) + " " + row.item["shareholder_pt"] + "%" }}
                  //- //   div(v-if="downlineLevel >= 5")
                  //- //     span.small {{ $helpers.getUplineName(5) + " " + row.item["s_senior_pt"] + "%" }}
                  //- //   div(v-if="downlineLevel >= 4")
                  //- //     span.small {{ $helpers.getUplineName(4) + " " + row.item["senior_pt"] + "%" }}
                  //- //   div(v-if="downlineLevel >= 3")
                  //- //     span.small {{ $helpers.getUplineName(3) + " " + row.item["master_pt"] + "%" }}
                  //- //   div.pt-col(v-if="downlineLevel >= 2")
                  //- //     span.small {{ $helpers.getUplineName(2) + " " + row.item["agent_pt"] + "%" }}
                  template(v-slot:cell(gross_winlose)="row" v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                    span(:class="$helpers.getNumberClass(row.item.gross_winlose)") #[b {{ row.item.gross_winlose | currency }} ]
                  //- // template(v-slot:cell(gross_comm)="row")
                  //- //   span(:class="$helpers.getNumberClass(row.item.gross_comm)") #[b {{ row.item.gross_comm | currency }} ]
                  template(v-slot:cell(member_winlose)="row")
                    span(:class="$helpers.getNumberClass(row.item.member_winlose)") #[b {{ row.item.member_winlose | currency }} ]
                  //- // template(v-slot:cell(member_comm)="row")
                  //- //   span(:class="$helpers.getNumberClass(row.item.member_comm)") #[b {{ row.item.member_comm | currency }} ]
                  //- // template(v-slot:cell(member_winlose_comm)="row")
                  //- //   span(:class="$helpers.getNumberClass(row.item.member_winlose_comm)") #[b {{ row.item.member_winlose_comm | currency }} ]
                  //- // template(v-slot:cell(agent_winlose)="row")
                  //- //   span(:class="$helpers.getNumberClass(row.item.agent_winlose)") #[b {{ row.item.agent_winlose | currency }} ]
                  //- // template(v-slot:cell(agent_comm)="row")
                  //- //   span(:class="$helpers.getNumberClass(row.item.agent_comm)") #[b {{ row.item.agent_comm | currency }} ]
                  //- // template(v-slot:cell(agent_winlose_comm)="row")
                  //- //   span(:class="$helpers.getNumberClass(row.item.agent_winlose_comm)") #[b {{ row.item.agent_winlose_comm | currency }} ]
                  //- // template(v-slot:cell(company_winlose)="row")
                  //- //   span(:class="$helpers.getNumberClass(row.item.company_winlose)") #[b {{ row.item.company_winlose | currency }} ]
                  //- // template(v-slot:cell(company_comm)="row")
                  //- //   span(:class="$helpers.getNumberClass(row.item.company_comm)") #[b {{ row.item.company_comm | currency }} ]
                  //- // template(v-slot:cell(company_winlose_comm)="row")
                  //- //   span(:class="$helpers.getNumberClass(row.item.company_winlose_comm)") #[b {{ row.item.company_winlose_comm | currency }} ]
                  template(v-slot:bottom-row="row" v-if="showTotal")
                    td.text-right(colspan="5")
                      span #[b {{ $t("ui.sub_total") }}]
                      br
                      span #[b {{ $t("ui.grand_total") }} ]
                    td.text-right(v-if="['TOURNAMENT'].includes(product)")
                      span(:class="$helpers.getNumberClass(subTotalJackpotPayout)")  #[b {{ subTotalJackpotPayout | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalJackpotPayout)")  #[b {{ grandTotalJackpotPayout | currency }} ]
                    td.text-right(v-if="['SPORTSBOOK','ADJUSTMENT'].includes(product)")
                      span(:class="$helpers.getNumberClass(subTotalGrossWinlose)")  #[b {{ subTotalGrossWinlose | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalGrossWinlose)")  #[b {{ grandTotalGrossWinlose | currency }} ]
                    //- // td.text-right
                    //- //   span(:class="$helpers.getNumberClass(subTotalGrossCommission)")  #[b {{ subTotalGrossCommission | currency }}]
                    //- //   br
                    //- //   span(:class="$helpers.getNumberClass(grandTotalGrossCommission)")  #[b {{ grandTotalGrossCommission | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalMemberWinlose)")  #[b {{ subTotalMemberWinlose | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalMemberWinlose)")  #[b {{ grandTotalMemberWinlose | currency }} ]
                    //- // td.text-right
                    //- //   span(:class="$helpers.getNumberClass(subTotalMemberCommission)")  #[b {{ subTotalMemberCommission | currency }}]
                    //- //   br
                    //- //   span(:class="$helpers.getNumberClass(grandTotalMemberCommission)")  #[b {{ grandTotalMemberCommission | currency }} ]
                    //- // td.text-right
                    //- //   span(:class="$helpers.getNumberClass(subTotalMemberWinloseCommission)")  #[b {{ subTotalMemberWinloseCommission | currency }}]
                    //- //   br
                    //- //   span(:class="$helpers.getNumberClass(grandTotalMemberWinloseCommission)")  #[b {{ grandTotalMemberWinloseCommission | currency }} ]
                    //- // td.text-right
                    //- //   span(:class="$helpers.getNumberClass(subTotalAgentWinlose)")  #[b {{ subTotalAgentWinlose | currency }}]
                    //- //   br
                    //- //   span(:class="$helpers.getNumberClass(grandTotalAgentWinlose)")  #[b {{ grandTotalAgentWinlose | currency }} ]
                    //- // td.text-right
                    //- //   span(:class="$helpers.getNumberClass(subTotalAgentCommission)")  #[b {{ subTotalAgentCommission | currency }}]
                    //- //   br
                    //- //   span(:class="$helpers.getNumberClass(grandTotalAgentCommission)")  #[b {{ grandTotalAgentCommission | currency }} ]
                    //- // td.text-right
                    //- //   span(:class="$helpers.getNumberClass(subTotalAgentWinloseCommission)")  #[b {{ subTotalAgentWinloseCommission | currency }}]
                    //- //   br
                    //- //   span(:class="$helpers.getNumberClass(grandTotalAgentWinloseCommission)")  #[b {{ grandTotalAgentWinloseCommission | currency }} ]
                    //- // td.text-right
                    //- //   span(:class="$helpers.getNumberClass(subTotalCompanyWinlose)")  #[b {{ subTotalCompanyWinlose | currency }}]
                    //- //   br
                    //- //   span(:class="$helpers.getNumberClass(grandTotalCompanyWinlose)")  #[b {{ grandTotalCompanyWinlose | currency }} ]
                    //- // td.text-right
                    //- //   span(:class="$helpers.getNumberClass(subTotalCompanyCommission)")  #[b {{ subTotalCompanyCommission | currency }}]
                    //- //   br
                    //- //   span(:class="$helpers.getNumberClass(grandTotalCompanyCommission)")  #[b {{ grandTotalCompanyCommission | currency }} ]
                    //- // td.text-right
                    //- //   span(:class="$helpers.getNumberClass(subTotalCompanyWinloseCommission)")  #[b {{ subTotalCompanyWinloseCommission | currency }}]
                    //- //   br
                    //- //   span(:class="$helpers.getNumberClass(grandTotalCompanyWinloseCommission)")  #[b {{ grandTotalCompanyWinloseCommission | currency }} ]
</template>

<script>
import config from "@/config";
import { required } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton.vue";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import DatePicker from "@/library/DatePicker.vue";
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    DateRangePicker,
    DatePicker,
    jsonToExcel
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      downlineLevel: this.$store.getters.accountType,
      product: this.$store.getters.getPlatform,
      member_id: this.$store.getters.getSelectedID,
      sport_type: this.$store.getters.getSportType,
      league_id: this.$store.getters.getLeagueID.id,
      match_id: this.$store.getters.getMatchID.id,
      game_name: "",
      game_provider: "",
      working_date: true,
      gameResultList: [],
      parlayList: [],
      isMMO: false,
      subTotalGrossWinlose: 0,
      grandTotalGrossWinlose: 0,
      // subTotalGrossCommission: 0,
      grandTotalGrossCommission: 0,
      // member
      subTotalMemberWinlose: 0,
      grandTotalMemberWinlose: 0,
      subTotalMemberCommission: 0,
      grandTotalMemberCommission: 0,
      subTotalMemberWinloseCommission: 0,
      grandTotalMemberWinloseCommission: 0,
      // agent / current login level
      subTotalAgentWinlose: 0,
      grandTotalAgentWinlose: 0,
      subTotalAgentCommission: 0,
      grandTotalAgentCommission: 0,
      subTotalAgentWinloseCommission: 0,
      grandTotalAgentWinloseCommission: 0,
      // company
      subTotalCompanyWinlose: 0,
      grandTotalCompanyWinlose: 0,
      subTotalCompanyCommission: 0,
      grandTotalCompanyCommission: 0,
      subTotalCompanyWinloseCommission: 0,
      grandTotalCompanyWinloseCommission: 0,

      subTotalJackpotPayout: 0,
      grandTotalJackpotPayout: 0,
      subTotalTurnover: 0,
      grandTotalTurnover: 0,
      subTotalValidTurnover: 0,
      grandTotalValidTurnover: 0,

      subTotalMasterComm: 0,
      grandTotalMasterComm: 0,
      subTotalSeniorComm: 0,
      grandTotalSeniorComm: 0,
      subTotalSuperSeniorComm: 0,
      grandTotalSuperSeniorComm: 0,
      subTotalShareholderComm: 0,
      grandTotalShareholderComm: 0,

      showTotal: false,
      filter: null,
      sortBy: "bet_time",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0,
      match: [],
      league: [],
      matchParlay: [],
      leagueParlay: []
    };
  },
  validations: {
    member_id: {
      required
    }
  },
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "bet_time",
          label: this.$t("ui.date_time"),
          sortable: true,
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "member_id",
          label: this.$t("ui.member_id"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "event",
          label: this.$t("ui.event"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "20%"
          }
        },
        {
          key: "detail",
          label: this.$t("ui.detail"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        ['TOURNAMENT'].includes(this.product) ? {
          key: "jackpot_payout",
          label: this.$t("ui.jackpot"),
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "7%"
          }
        } : {},
        // {
        //   key: "pt_share",
        //   label: this.$t("ui.pt_share"),
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-lighter",
        //   thStyle: {
        //     width: "10%"
        //   }
        // },
        ['SPORTSBOOK','ADJUSTMENT'].includes(this.product) ? {
          key: "gross_winlose",
          label: this.$t("ui.gross_winlose"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "7%"
          }
        } : {},
        // {
        //   key: "gross_comm",
        //   label: this.$t("ui.gross_commission"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-lighter",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        {
          key: "member_winlose",
          label: this.$t("ui.winlose_column1"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-transparent-1",
          thStyle: {
            width: "12%"
          }
        },
        // {
        //   key: "member_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-transparent-1",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "member_winlose_comm",
        //   label: this.$t("ui.total"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-transparent-1",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "agent_winlose",
        //   label: this.$t("ui.winlose_column1"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-transparent-3",
        //   thStyle: {
        //     width: "20%"
        //   }
        // },
        // {
        //   key: "agent_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-transparent-3",
        //   thStyle: {
        //     width: "7%"
        //   }
        // },
        // {
        //   key: "agent_winlose_comm",
        //   label: this.$t("ui.total"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-transparent-3",
        //   thStyle: {
        //     width: "10px"
        //   }
        // },
        // {
        //   key: "company_winlose",
        //   label: this.$t("ui.winlose_column1"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-transparent-5",
        //   thStyle: {
        //     width: "10px"
        //   }
        // },
        // {
        //   key: "company_comm",
        //   label: this.$t("ui.winlose_column2"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-transparent-5",
        //   thStyle: {
        //     width: "10px"
        //   }
        // },
        // {
        //   key: "company_winlose_comm",
        //   label: this.$t("ui.total"),
        //   sortable: true,
        //   class: "align-middle text-right",
        //   thClass: "align-middle bg-grey-transparent-5",
        //   thStyle: {
        //     width: "10px"
        //   }
        // }
      ]
    },
    vDfields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "working_date",
          label: this.$t("ui.date"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "league_name",
          label: this.$t("ui.league_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "home_team_name",
          label: this.$t("ui.home_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "away_team_name",
          label: this.$t("ui.away_team_name"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "full_half",
          label: this.$t("ui.match_time"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet_type",
          label: this.$t("ui.bet_type"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "bet",
          label: this.$t("ui.bet"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "odds_display",
          label: this.$t("ui.odds_display"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "payout_odds",
          label: this.$t("ui.payout"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "final_home",
          label: this.$t("ui.home_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "final_away",
          label: this.$t("ui.away_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "running_score",
          label: this.$t("ui.running_score"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter"
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "desc" : "asc"
    },
    subTotal() {
      return [
        this.subTotalGrossWinlose.toFixed(2),
        // this.subTotalGrossCommission.toFixed(2),
        this.subTotalMemberWinlose.toFixed(2),
        this.subTotalMemberCommission.toFixed(2),
        this.subTotalMemberWinloseCommission.toFixed(2),
        this.subTotalAgentWinlose.toFixed(2),
        this.subTotalAgentCommission.toFixed(2),
        this.subTotalAgentWinloseCommission.toFixed(2),
        this.subTotalCompanyWinlose.toFixed(2),
        this.subTotalCompanyCommission.toFixed(2),
        this.subTotalCompanyWinloseCommission.toFixed(2)
      ]
    },
    grandTotal() {
      return [
        this.grandTotalGrossWinlose.toFixed(2),
        this.grandTotalGrossCommission.toFixed(2),
        this.grandTotalMemberWinlose.toFixed(2),
        this.grandTotalMemberCommission.toFixed(2),
        this.grandTotalMemberWinloseCommission.toFixed(2),
        this.grandTotalAgentWinlose.toFixed(2),
        this.grandTotalAgentCommission.toFixed(2),
        this.grandTotalAgentWinloseCommission.toFixed(2),
        this.grandTotalCompanyWinlose.toFixed(2),
        this.grandTotalCompanyCommission.toFixed(2),
        this.grandTotalCompanyWinloseCommission.toFixed(2)
      ]
    },
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    }
  },
  mounted: function() {
    // this.$store.dispatch("user/getPlatformLookUp")
    if(this.member_id != ""){
      this.submit()
    }
  },
  methods: {
    // resultUrl(e) {
    //   let mode = this.product
    //   switch(mode) {
    //     case "SLOTS":
    //       return config.r2ResultUrl() + e.bet_id
    //     case "LIVECASINO":
    //       var account_id = this.$store.getters.accountID
    //       var login_id = this.$store.getters.loginID
    //       var profile_id = this.$store.getters.profileID
    //       var auth_token = this.$store.getters.authToken
    //       var result = config.r1ResultUrl() + "account_id=" + account_id + "&login_id=" + login_id + "&profile_id=" + profile_id + "&auth_token=" + auth_token +  "&result_id=" + e.result_id
    //       return encodeURI(result);
    //   }
    // },
    getPlatformLookUp: function() {
      let z = [
        { value: "SPORTSBOOK", text: this.$t("ui.sportsbook").toUpperCase() },
        { value: "TOURNAMENT", text: this.$t("ui.tournament").toUpperCase() },
        // { value: "ADJUSTMENT", text: this.$t("ui.adjustment").toUpperCase() }
      ]
      return z
    },
    getBetType(item) {
      let type = item.bet_type
      let share = item.bet_type_share

      if(type == 'HDP' && share == 'HDPMMO') {
        return this.$tc("m.BT_HDPMMO")
      }

      if(type == 'OU' && share == 'HDPMMO') {
        return this.$tc("m.BT_OUMMO")
      }

      return this.$tc("m.BT_" + type, 2)
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "asc"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    submit: function() {
      this.$v.$touch()
      this.gameResultList = []
      if (!this.$v.$invalid) {
        let product = this.product
        switch(product) {
          case 'SPORTSBOOK':
            this.getSportsbookResult()
            break
          case 'TOURNAMENT':
            this.getTournamentResult()
            break
          // case 'ADJUSTMENT':
          //   this.getSportsbookResultRefundDetail()
          //   break
          // case 'LIVECASINO':
          //   this.getLivecasinoResult()
          //   break
          // case 'SLOTS':
          //   this.getSlotgamesResult()
          //   break
          default:
            this.getSportsbookResult();
            break;
        }
      }
    },
    getName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.league.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language] && x["name_" + this.language] != null) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.match.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    getParlayName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.leagueParlay.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language] && x["name_" + this.language] != null) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.matchParlay.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    getSportsbookResult: function() {
      let url = config.getGameResultSportsbookUrl()
      let member_id = this.member_id
      let sport_type = this.sport_type
      let league_id = this.league_id
      let match_id = this.match_id
      let search_by_working_date = (this.working_date) ? 1 : 0
      let start_date = this.dateRange.startDate
      let end_date = this.dateRange.endDate
      let page_number = this.currentPage
      this.currentPage = parseInt(page_number)
      let page_size = this.perPage
      let sort_key = this.sortBy
      let sort_type = this.direction
      this.loading = true
      this.$store
        .dispatch("user/getGameResult", { url, member_id, start_date, end_date, search_by_working_date, sport_type, league_id, match_id, page_number, page_size, sort_key, sort_type })
        .then(response => {
          this.clearTotal()
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.showTotal = true
              this.gameResultList = response.data
              this.match = response.names.match
              this.league = response.names.league
              this.totalRows = response.data.length > 0 ? this.gameResultList[0]["totalrows"] : 0

              response.data.forEach(value => {
                this.subTotalGrossWinlose = parseFloat(this.subTotalGrossWinlose) + parseFloat(value["gross_winlose"])
                // this.subTotalGrossCommission = parseFloat(this.subTotalGrossCommission) + parseFloat(value["gross_comm"])

                this.subTotalMemberWinlose = parseFloat(this.subTotalMemberWinlose) + parseFloat(value["member_winlose"])
                this.subTotalMemberCommission = parseFloat(this.subTotalMemberCommission) + parseFloat(value["member_comm"])
                this.subTotalMemberWinloseCommission = parseFloat(this.subTotalMemberWinloseCommission) + parseFloat(value["member_winlose_comm"])

                this.subTotalAgentWinlose = parseFloat(this.subTotalAgentWinlose) + parseFloat(value["agent_winlose"])
                this.subTotalAgentCommission = parseFloat(this.subTotalAgentCommission) + parseFloat(value["agent_comm"])
                this.subTotalAgentWinloseCommission = parseFloat(this.subTotalAgentWinloseCommission) + parseFloat(value["agent_winlose_comm"])

                this.subTotalCompanyWinlose = parseFloat(this.subTotalCompanyWinlose) + parseFloat(value["company_winlose"])
                this.subTotalCompanyCommission = parseFloat(this.subTotalCompanyCommission) + parseFloat(value["company_comm"])
                this.subTotalCompanyWinloseCommission = parseFloat(this.subTotalCompanyWinloseCommission) + parseFloat(value["company_winlose_comm"])
              })

              if(response.grandTotal.length > 0) {
                this.grandTotalGrossWinlose = response.grandTotal[0]["gross_winlose"]
                // this.grandTotalGrossCommission = response.grandTotal[0]["gross_comm"]

                this.grandTotalMemberWinlose = response.grandTotal[0]["member_winlose"]
                this.grandTotalMemberCommission = response.grandTotal[0]["member_comm"]
                this.grandTotalMemberWinloseCommission = response.grandTotal[0]["member_winlose_comm"]

                this.grandTotalAgentWinlose = response.grandTotal[0]["agent_winlose"]
                this.grandTotalAgentCommission = response.grandTotal[0]["agent_comm"]
                this.grandTotalAgentWinloseCommission = response.grandTotal[0]["agent_winlose_comm"]

                this.grandTotalCompanyWinlose = response.grandTotal[0]["company_winlose"]
                this.grandTotalCompanyCommission = response.grandTotal[0]["company_comm"]
                this.grandTotalCompanyWinloseCommission = response.grandTotal[0]["company_winlose_comm"]
              }
            } else {
              this.clearTotal()
            }
          } else {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
          }
        })
        .catch(response => {
          this.loading = false
          this.clearTotal()
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });

    },
    getSportsbookResultRefundDetail: function() {
      let url = config.getGameResultSportsbookRefundUrl()
      let member_id = this.member_id
      let sport_type = this.sport_type
      let league_id = this.league_id
      let match_id = this.match_id
      let search_by_working_date = (this.working_date) ? 1 : 0
      let start_date = this.dateRange.startDate
      let end_date = this.dateRange.endDate
      let page_number = this.currentPage
      this.currentPage = parseInt(page_number)
      let page_size = this.perPage
      let sort_key = this.sortBy
      let sort_type = this.direction
      this.loading = true
      this.$store
        .dispatch("user/getGameResult", { url, member_id, start_date, end_date, search_by_working_date, sport_type, league_id, match_id, page_number, page_size, sort_key, sort_type })
        .then(response => {
          this.clearTotal()
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.showTotal = true
              this.gameResultList = response.data
              this.match = response.names.match
              this.league = response.names.league
              this.totalRows = response.data.length > 0 ? this.gameResultList[0]["totalrows"] : 0

              response.data.forEach(value => {
                this.subTotalGrossWinlose = parseFloat(this.subTotalGrossWinlose) + parseFloat(value["gross_winlose"])
                // this.subTotalGrossCommission = parseFloat(this.subTotalGrossCommission) + parseFloat(value["gross_comm"])

                this.subTotalMemberWinlose = parseFloat(this.subTotalMemberWinlose) + parseFloat(value["member_winlose"])
                this.subTotalMemberCommission = parseFloat(this.subTotalMemberCommission) + parseFloat(value["member_comm"])
                this.subTotalMemberWinloseCommission = parseFloat(this.subTotalMemberWinloseCommission) + parseFloat(value["member_winlose_comm"])

                this.subTotalAgentWinlose = parseFloat(this.subTotalAgentWinlose) + parseFloat(value["agent_winlose"])
                this.subTotalAgentCommission = parseFloat(this.subTotalAgentCommission) + parseFloat(value["agent_comm"])
                this.subTotalAgentWinloseCommission = parseFloat(this.subTotalAgentWinloseCommission) + parseFloat(value["agent_winlose_comm"])

                this.subTotalCompanyWinlose = parseFloat(this.subTotalCompanyWinlose) + parseFloat(value["company_winlose"])
                this.subTotalCompanyCommission = parseFloat(this.subTotalCompanyCommission) + parseFloat(value["company_comm"])
                this.subTotalCompanyWinloseCommission = parseFloat(this.subTotalCompanyWinloseCommission) + parseFloat(value["company_winlose_comm"])
              })

              if(response.grandTotal.length > 0) {
                this.grandTotalGrossWinlose = response.grandTotal[0]["gross_winlose"]
                // this.grandTotalGrossCommission = response.grandTotal[0]["gross_comm"]

                this.grandTotalMemberWinlose = response.grandTotal[0]["member_winlose"]
                this.grandTotalMemberCommission = response.grandTotal[0]["member_comm"]
                this.grandTotalMemberWinloseCommission = response.grandTotal[0]["member_winlose_comm"]

                this.grandTotalAgentWinlose = response.grandTotal[0]["agent_winlose"]
                this.grandTotalAgentCommission = response.grandTotal[0]["agent_comm"]
                this.grandTotalAgentWinloseCommission = response.grandTotal[0]["agent_winlose_comm"]

                this.grandTotalCompanyWinlose = response.grandTotal[0]["company_winlose"]
                this.grandTotalCompanyCommission = response.grandTotal[0]["company_comm"]
                this.grandTotalCompanyWinloseCommission = response.grandTotal[0]["company_winlose_comm"]
              }
            } else {
              this.clearTotal()
            }
          } else {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
          }
        })
        .catch(response => {
          this.loading = false
          this.clearTotal()
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });

    },
    getTournamentResult: function() {
      let url = config.getGameResultTournamentDetailUrl()
      let member_id = this.member_id
      let search_by_working_date = (this.working_date) ? 1 : 0
      let start_date = this.dateRange.startDate
      let end_date = this.dateRange.endDate
      let page_number = this.currentPage
      this.currentPage = parseInt(page_number)
      let page_size = this.perPage
      let sort_key = this.sortBy
      let sort_type = this.direction
      this.loading = true
      this.$store
        .dispatch("user/getGameResultTournamentDetail", { url, member_id, start_date, end_date, search_by_working_date, page_number, page_size, sort_key, sort_type })
        .then(response => {
          this.clearTotal()
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.showTotal = true
              this.gameResultList = response.data
              this.totalRows = response.data.length > 0 ? this.gameResultList[0]["totalrows"] : 0

              response.data.forEach(value => {
                this.subTotalGrossWinlose = parseFloat(this.subTotalGrossWinlose) + parseFloat(value["gross_winlose"])
                // this.subTotalGrossCommission = parseFloat(this.subTotalGrossCommission) + parseFloat(value["gross_comm"])

                this.subTotalMemberWinlose = parseFloat(this.subTotalMemberWinlose) + parseFloat(value["member_winlose"])
                this.subTotalMemberCommission = parseFloat(this.subTotalMemberCommission) + parseFloat(value["member_comm"])
                this.subTotalMemberWinloseCommission = parseFloat(this.subTotalMemberWinloseCommission) + parseFloat(value["member_winlose_comm"])

                this.subTotalAgentWinlose = parseFloat(this.subTotalAgentWinlose) + parseFloat(value["agent_winlose"])
                this.subTotalAgentCommission = parseFloat(this.subTotalAgentCommission) + parseFloat(value["agent_comm"])
                this.subTotalAgentWinloseCommission = parseFloat(this.subTotalAgentWinloseCommission) + parseFloat(value["agent_winlose_comm"])

                this.subTotalCompanyWinlose = parseFloat(this.subTotalCompanyWinlose) + parseFloat(value["company_winlose"])
                this.subTotalCompanyCommission = parseFloat(this.subTotalCompanyCommission) + parseFloat(value["company_comm"])
                this.subTotalCompanyWinloseCommission = parseFloat(this.subTotalCompanyWinloseCommission) + parseFloat(value["company_winlose_comm"])
              })

              if(response.grandTotal.length > 0) {
                this.grandTotalGrossWinlose = response.grandTotal[0]["gross_winlose"]
                // this.grandTotalGrossCommission = response.grandTotal[0]["gross_comm"]

                this.grandTotalMemberWinlose = response.grandTotal[0]["member_winlose"]
                this.grandTotalMemberCommission = response.grandTotal[0]["member_comm"]
                this.grandTotalMemberWinloseCommission = response.grandTotal[0]["member_winlose_comm"]

                this.grandTotalAgentWinlose = response.grandTotal[0]["agent_winlose"]
                this.grandTotalAgentCommission = response.grandTotal[0]["agent_comm"]
                this.grandTotalAgentWinloseCommission = response.grandTotal[0]["agent_winlose_comm"]

                this.grandTotalCompanyWinlose = response.grandTotal[0]["company_winlose"]
                this.grandTotalCompanyCommission = response.grandTotal[0]["company_comm"]
                this.grandTotalCompanyWinloseCommission = response.grandTotal[0]["company_winlose_comm"]
              }
            } else {
              this.clearTotal()
            }
          } else {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
          }
        })
        .catch(response => {
          this.loading = false
          this.clearTotal()
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });

    },
    // getLivecasinoResult: function() {
    //   let url = config.getGameResultLivecasinoUrl()
    //   let member_id = this.member_id
    //   let game_name = this.game_name
    //   let game_provider = this.game_provider
    //   let search_by_working_date = (this.working_date) ? 1 : 0
    //   let start_date = this.dateRange.startDate
    //   let end_date = this.dateRange.endDate
    //   let page_number = this.currentPage
    //   this.currentPage = parseInt(page_number)
    //   let page_size = this.perPage
    //   let sort_key = this.sortBy
    //   let sort_type = this.direction
    //   this.loading = true
    //   this.$store
    //     .dispatch("user/getGameResult", { url, member_id, start_date, end_date, search_by_working_date, game_name, game_provider, page_number, page_size, sort_key, sort_type })
    //     .then(response => {
    //       this.clearTotal()
    //       this.loading = false
    //       this.submission.success = response.success
    //       this.submission.status = response.errorTag
    //       if (this.submission.success == true) {
    //         if(response.data.length > 0) {
    //           this.showTotal = true
    //           this.gameResultList = response.data
    //           this.totalRows = response.data.length > 0 ? this.gameResultList[0]["totalrows"] : 0

    //           response.data.forEach(value => {
    //             this.subTotalGrossWinlose = parseFloat(this.subTotalGrossWinlose) + parseFloat(value["gross_winlose"])
    //             this.subTotalGrossCommission = parseFloat(this.subTotalGrossCommission) + parseFloat(value["gross_comm"])

    //             this.subTotalMemberWinlose = parseFloat(this.subTotalMemberWinlose) + parseFloat(value["member_winlose"])
    //             this.subTotalMemberCommission = parseFloat(this.subTotalMemberCommission) + parseFloat(value["member_comm"])
    //             this.subTotalMemberWinloseCommission = parseFloat(this.subTotalMemberWinloseCommission) + parseFloat(value["member_winlose_comm"])

    //             this.subTotalAgentWinlose = parseFloat(this.subTotalAgentWinlose) + parseFloat(value["agent_winlose"])
    //             this.subTotalAgentCommission = parseFloat(this.subTotalAgentCommission) + parseFloat(value["agent_comm"])
    //             this.subTotalAgentWinloseCommission = parseFloat(this.subTotalAgentWinloseCommission) + parseFloat(value["agent_winlose_comm"])

    //             this.subTotalCompanyWinlose = parseFloat(this.subTotalCompanyWinlose) + parseFloat(value["company_winlose"])
    //             this.subTotalCompanyCommission = parseFloat(this.subTotalCompanyCommission) + parseFloat(value["company_comm"])
    //             this.subTotalCompanyWinloseCommission = parseFloat(this.subTotalCompanyWinloseCommission) + parseFloat(value["company_winlose_comm"])
    //           })

    //           if(response.grandTotal.length > 0) {
    //             this.grandTotalGrossWinlose = response.grandTotal[0]["gross_winlose"]
    //             this.grandTotalGrossCommission = response.grandTotal[0]["gross_comm"]

    //             this.grandTotalMemberWinlose = response.grandTotal[0]["member_winlose"]
    //             this.grandTotalMemberCommission = response.grandTotal[0]["member_comm"]
    //             this.grandTotalMemberWinloseCommission = response.grandTotal[0]["member_winlose_comm"]

    //             this.grandTotalAgentWinlose = response.grandTotal[0]["agent_winlose"]
    //             this.grandTotalAgentCommission = response.grandTotal[0]["agent_comm"]
    //             this.grandTotalAgentWinloseCommission = response.grandTotal[0]["agent_winlose_comm"]

    //             this.grandTotalCompanyWinlose = response.grandTotal[0]["company_winlose"]
    //             this.grandTotalCompanyCommission = response.grandTotal[0]["company_comm"]
    //             this.grandTotalCompanyWinloseCommission = response.grandTotal[0]["company_winlose_comm"]
    //           }
    //         } else {
    //           this.clearTotal()
    //         }
    //       } else {
    //         this.loading = false
    //         this.submission.success = response.success
    //         this.submission.status = response.errorTag
    //       }
    //     })
    //     .catch(response => {
    //       this.loading = false
    //       this.clearTotal()
    //       this.submission.success = response.success
    //       this.submission.status = this.$t("message." + response.errorTag)
    //     });
    // },
    // getSlotgamesResult: function() {
    //   let url = config.getGameResultSlotsUrl()
    //   let member_id = this.member_id
    //   let game_name = this.game_name
    //   let game_provider = this.game_provider
    //   let search_by_working_date = (this.working_date) ? 1 : 0
    //   let start_date = this.dateRange.startDate
    //   let end_date = this.dateRange.endDate
    //   let page_number = this.currentPage
    //   this.currentPage = parseInt(page_number)
    //   let page_size = this.perPage
    //   let sort_key = this.sortBy
    //   let sort_type = this.direction
    //   this.loading = true
    //   this.$store
    //     .dispatch("user/getGameResult", { url, member_id, start_date, end_date, search_by_working_date, game_name, game_provider, page_number, page_size, sort_key, sort_type })
    //     .then(response => {
    //       this.clearTotal()
    //       this.loading = false
    //       this.submission.success = response.success
    //       this.submission.status = response.errorTag
    //       if (this.submission.success == true) {
    //         if(response.data.length > 0) {
    //           this.showTotal = true
    //           this.gameResultList = response.data
    //           this.totalRows = response.data.length > 0 ? this.gameResultList[0]["totalrows"] : 0

    //           response.data.forEach(value => {
    //             this.subTotalGrossWinlose = parseFloat(this.subTotalGrossWinlose) + parseFloat(value["gross_winlose"])
    //             this.subTotalGrossCommission = parseFloat(this.subTotalGrossCommission) + parseFloat(value["gross_comm"])

    //             this.subTotalMemberWinlose = parseFloat(this.subTotalMemberWinlose) + parseFloat(value["member_winlose"])
    //             this.subTotalMemberCommission = parseFloat(this.subTotalMemberCommission) + parseFloat(value["member_comm"])
    //             this.subTotalMemberWinloseCommission = parseFloat(this.subTotalMemberWinloseCommission) + parseFloat(value["member_winlose_comm"])

    //             this.subTotalAgentWinlose = parseFloat(this.subTotalAgentWinlose) + parseFloat(value["agent_winlose"])
    //             this.subTotalAgentCommission = parseFloat(this.subTotalAgentCommission) + parseFloat(value["agent_comm"])
    //             this.subTotalAgentWinloseCommission = parseFloat(this.subTotalAgentWinloseCommission) + parseFloat(value["agent_winlose_comm"])

    //             this.subTotalCompanyWinlose = parseFloat(this.subTotalCompanyWinlose) + parseFloat(value["company_winlose"])
    //             this.subTotalCompanyCommission = parseFloat(this.subTotalCompanyCommission) + parseFloat(value["company_comm"])
    //             this.subTotalCompanyWinloseCommission = parseFloat(this.subTotalCompanyWinloseCommission) + parseFloat(value["company_winlose_comm"])
    //           })

    //           if(response.grandTotal.length > 0) {
    //             this.grandTotalGrossWinlose = response.grandTotal[0]["gross_winlose"];
    //             this.grandTotalGrossCommission = response.grandTotal[0]["gross_comm"];

    //             this.grandTotalMemberWinlose = response.grandTotal[0]["member_winlose"];
    //             this.grandTotalMemberCommission = response.grandTotal[0]["member_comm"];
    //             this.grandTotalMemberWinloseCommission = response.grandTotal[0]["member_winlose_comm"];

    //             this.grandTotalAgentWinlose = response.grandTotal[0]["agent_winlose"];
    //             this.grandTotalAgentCommission = response.grandTotal[0]["agent_comm"];
    //             this.grandTotalAgentWinloseCommission = response.grandTotal[0]["agent_winlose_comm"];

    //             this.grandTotalCompanyWinlose = response.grandTotal[0]["company_winlose"];
    //             this.grandTotalCompanyCommission = response.grandTotal[0]["company_comm"];
    //             this.grandTotalCompanyWinloseCommission = response.grandTotal[0]["company_winlose_comm"];
    //           }
    //         } else {
    //           this.clearTotal()
    //         }
    //       } else {
    //         this.loading = false
    //         this.submission.success = response.success
    //         this.submission.status = response.errorTag
    //       }
    //     })
    //     .catch(response => {
    //       this.loading = false
    //       this.clearTotal()
    //       this.submission.success = response.success
    //       this.submission.status = this.$t("message." + response.errorTag)
    //     });
    // },
    getParlayDetail: function(item) {
      this.isMMO = false
      this.parlayList = []
      if(item._showDetails) {
        this.gameResultList.forEach(value => {
          this.$set(value, '_showDetails', false)
        })
        this.$set(item, '_showDetails', true)
      }
      let bet_id = item.result_id
      this.$store
        .dispatch("user/getMatchResultParlayDetail", { bet_id })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.parlayList = response.data
              this.matchParlay = response.names.match
              this.leagueParlay = response.names.league
            }
          } else {
            this.submission.success = response.success
            this.submission.status = response.errorTag
          }
        })
        .catch(response => {
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    getParlayDetailMMO: function(item) {
      this.isMMO = true
      this.parlayList = [];
      if (item._showDetails) {
        this.gameResultList.forEach(value => {
          this.$set(value, "_showDetails", false);
        });
        this.$set(item, "_showDetails", true);
      }
      let bet_id = item.result_id;
      this.$store
        .dispatch("user/getMatchResultMMOParlayDetail", { bet_id })
        .then(response => {
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.parlayList = response.data
              this.matchParlay = response.names.match
              this.leagueParlay = response.names.league
            }
          } else {
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    clearTotal() {
      this.$store.dispatch("layout/setSportType", "")
      this.$store.getters.getLeagueID.id = ""
      this.$store.getters.getMatchID.id = ""

      this.showTotal = false
      this.gameResultList = []
      this.totalRows = 0
      this.subTotalGrossWinlose = 0
      this.grandTotalGrossWinlose = 0
      // this.subTotalGrossCommission = 0
      this.grandTotalGrossCommission = 0
      this.subTotalMemberWinlose = 0
      this.grandTotalMemberWinlose = 0
      this.subTotalMemberCommission = 0
      this.grandTotalMemberCommission = 0
      this.subTotalMemberWinloseCommission = 0
      this.grandTotalMemberWinloseCommission = 0
      this.subTotalAgentWinlose = 0
      this.grandTotalAgentWinlose = 0
      this.subTotalAgentCommission = 0
      this.grandTotalAgentCommission = 0
      this.subTotalAgentWinloseCommission = 0
      this.grandTotalAgentWinloseCommission = 0
      this.subTotalCompanyWinlose = 0
      this.grandTotalCompanyWinlose = 0
      this.subTotalCompanyCommission = 0
      this.grandTotalCompanyCommission = 0
      this.subTotalCompanyWinloseCommission = 0
      this.grandTotalCompanyWinloseCommission = 0
    }
  }
};
</script>

<style lang="scss" scoped>
  .custom-checkbox {
    width: 100% !important;
  }
</style>